import { createApp } from "vue";
import App from "./layouts/App.vue";
import { router } from "./router";
import { store } from "./store";
import i18n from "./i18n";
import registerGlobalDirectives from "./plugins/global-directives";
import registerGlobalFilters from "./plugins/global-filters";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import mitt from "mitt";
import "tailwindcss/base.css";
import "tailwindcss/components.css";
import "tailwindcss/utilities.css";
import "./assets/styles/main.scss";

import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import HighchartsVue from "highcharts-vue";

Stock(Highcharts);

const emitter = mitt();

const app = createApp(App);

app.provide("emitter", emitter);

registerGlobalDirectives(app);

registerGlobalFilters(app);
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
app.use(HighchartsVue);
app
  .use(store)
  .use(router)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyBUtHXFnCfCYGNhBawTgwo2fbqK-143X3E"
    }
  })
  .use(i18n)
  .mount("#app");
